var map = {
	"./icons_UI_icon_X.svg": "d338",
	"./icons_UI_icon_X_auswertung.svg": "92b5",
	"./icons_UI_icon_again.svg": "a096",
	"./icons_UI_icon_again_black.svg": "2b4e",
	"./icons_UI_icon_check.svg": "b942",
	"./icons_UI_icon_check_mint.svg": "d3fe",
	"./icons_UI_icon_missed.svg": "92e9",
	"./icons_UI_icon_missed_mint.svg": "9a82",
	"./icons_UI_icon_wrong.svg": "e93e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "171e";